module.exports = __webpack_public_path__ + "q.no1.1d5cf07e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/q.no1.jpg
// module id = 78TL
// module chunks = 0